export default "__VITE_PUBLIC_ASSET__75a6e6f0__"